import {
  arrayBuilderItemSubsequentPageTitleUI,
  radioSchema,
  radioUI,
} from 'platform/forms-system/src/js/web-component-patterns';

import {
  ARRAY_PATH,
  SIDE_OF_BODY_LABELS,
  SIDE_OF_BODY_VALUES,
} from '../../../constants';
import { getAvailableSidesOfBody } from '../../../utils/duplicate-condition-names';
import { createNewConditionName } from './utils';

/** @returns {PageSchema} */
const sideOfBodyPage = {
  uiSchema: {
    ...arrayBuilderItemSubsequentPageTitleUI(
      ({ formData }) => createNewConditionName(formData, true),
      undefined,
      false,
    ),
    sideOfBody: radioUI({
      title: 'Which side of the body is your condition on?',
      labels: SIDE_OF_BODY_LABELS,
      // vets-api submits this as "<condition>, <side>", so a side already
      // claimed under this condition's name duplicates a disability name.
      updateSchema: (formData, _schema, _uiSchema, index, _path, fullData) => {
        const item = fullData?.[ARRAY_PATH]?.[index];
        const condition = formData?.condition ?? item?.condition;
        const currentSide = formData?.sideOfBody ?? item?.sideOfBody;

        return radioSchema(
          getAvailableSidesOfBody(fullData, index, condition, currentSide),
        );
      },
    }),
  },
  schema: {
    type: 'object',
    required: ['sideOfBody'],
    properties: {
      sideOfBody: radioSchema(SIDE_OF_BODY_VALUES),
    },
  },
};

export default sideOfBodyPage;
